import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TerminalsRoutingModule } from './terminals-routing.module';

@NgModule({
    declarations: [
    ],
    imports: [
        CommonModule,
        TerminalsRoutingModule
    ]
})
export class TerminalsModule { }
